import * as React from 'react';
import { Link } from 'react-router-dom';

import { ActionIcon, Anchor, Group, Image, Menu, Text } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { IconLogout } from '@tabler/icons-react';

import { AppAboutMenu } from './AppAboutMenu';
import logoURL from '../assets/bio-rad-logo.svg';
// import gearIcon from '../assets/icon-header-gear.svg';
import helpIcon from '../assets/icon-header-help.svg';
// import notificationIcon from '../assets/icon-header-notification.svg';
import userIcon from '../assets/icon-header-user.svg';

interface AppHeaderProps {
  userName?: string;
  userEmail?: string;
  onLogout: () => void;
}

export function AppHeader({ userName, userEmail, onLogout }: AppHeaderProps) {
  const [helpOpened, { open: openHelp, close: closeHelp }] = useDisclosure(false);

  return (
    <>
      <Group h="100%" px="md" justify="space-between" className="app-header">
        <Group>
          <Image h={30} src={logoURL} alt="Bio Rad logo" />
          <Anchor component={Link} to="/" size="lg" fw={400} c="brand" underline="never" data-testid="app-logo">
            ImmunoSense
          </Anchor>
        </Group>

        <Group gap={12}>
          {/* <ActionIcon variant="subtle" size="lg" aria-label="Settings">
            <img src={gearIcon} alt="Settings" width={20} height={20} />
          </ActionIcon> */}

          {/* <ActionIcon variant="subtle" size="lg" aria-label="Notifications">
            <img src={notificationIcon} alt="Notifications" width={20} height={20} />
          </ActionIcon> */}

          <Menu shadow="md" width={250} zIndex={1000}>
            <Menu.Target>
              <ActionIcon variant="subtle" size="lg" aria-label="User menu">
                <img src={userIcon} alt="User" width={20} height={20} />
              </ActionIcon>
            </Menu.Target>

            <Menu.Dropdown>
              <Menu.Label>Account</Menu.Label>
              {userName && <Menu.Item leftSection={<img src={userIcon} alt="" width={14} height={14} />}>{userName}</Menu.Item>}
              {userEmail && (
                <Menu.Item leftSection={<Text size="xs">@</Text>} disabled>
                  {userEmail}
                </Menu.Item>
              )}
              <Menu.Divider />
              <Menu.Item leftSection={<IconLogout size={14} />} onClick={onLogout} color="red">
                Sign Out
              </Menu.Item>
            </Menu.Dropdown>
          </Menu>

          <ActionIcon variant="subtle" size="lg" aria-label="Help" onClick={openHelp}>
            <img src={helpIcon} alt="Help" width={20} height={20} />
          </ActionIcon>
        </Group>
      </Group>

      <AppAboutMenu opened={helpOpened} onClose={closeHelp} />
    </>
  );
}
